import { Suspense, useEffect, useState } from 'react';

import LoadingSpinnerCenter from '~/components/LoadingSpinnerCenter';
import type { OAISchema } from '~/types/openapi';

import RecentlyViewedProducts from './RecentlyViewedProducts';
import SimilarProducts from './SimilarProducts';

type Props = {
  products: OAISchema['MarketSelectProductResponseV2'][];
};

const DisplayProducts = ({ products }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<
    OAISchema['MarketSelectProductResponseV2']
  >(products[0]);
  const [offerId, setOfferId] = useState<number>();

  useEffect(() => {
    setOfferId(selectedProduct.offerId);
  }, [selectedProduct]);

  return (
    <>
      <RecentlyViewedProducts
        products={products}
        selectedProduct={selectedProduct}
        setSelectedProduct={(
          product: OAISchema['MarketSelectProductResponseV2'],
        ) => setSelectedProduct(product)}
      />
      <Suspense
        fallback={
          <div className="h-[320px]">
            <LoadingSpinnerCenter />
          </div>
        }
      >
        <SimilarProducts selectedProduct={selectedProduct} offerId={offerId} />
      </Suspense>
    </>
  );
};

export default DisplayProducts;
